export const defaultCanvasStyle = {
  height: '35vh',
  width: '98%',
  position: 'relative'
};

export const defaultCameraConfig = {
  position: [0, 10, 10],
  fov: 60,
  zoom: 1,
  background: '#808080',
  lightSettings: {
    ambientLight: { intensity: 0.4 },
    spotLight: [
      { position: [60, 30, 0], angle: 0.3, intensity: 1, penumbra: 1, castShadow: true },
      { position: [-60, 30, 60], angle: 0.3, intensity: 1, penumbra: 1, castShadow: true },
      { position: [-60, 30, -60], angle: 0.3, intensity: 1, penumbra: 1, castShadow: true }
    ]
  },
  orbitControl: {
    enabled: true,
    maxDistance: 90,
    minDistance: 20,
    maxPolarAngle: Math.PI / 2.2
  }
};
